import React from 'react';
import './Banner.css';
import { Row, Image, Grid } from 'react-bootstrap';
import banner from '../imgs/banner-min.jpg';


const Banner = () => (
	<Grid>
	<div className="image">
	    <Row className="show-grid">
		  <Image id="ban" src={banner} alt="Banner" responsive />
	    </Row>
	    <Row className="textCenter caption show-grid ">
	    	<h2><span>Explore our Beautiful Properties Below</span></h2>
	    </Row>

    </div>
    </Grid>
)

export default Banner;


// WEBPACK FOOTER //
// ./src/components/Banner.js